/**
 * Chart.js dark theme options for MiEROS styling.
 * Use these options to ensure charts match the dark theme (no white backgrounds).
 */

// Theme colors matching _mieros-theme.scss
const TEXT_PRIMARY = '#F1F5F9';
const TEXT_SECONDARY = '#94A3B8';
const GRID_COLOR = 'rgba(255, 255, 255, 0.08)';

/** Base plugin config for all charts - transparent background, light text */
export const chartPlugins = {
  legend: {
    labels: {
      color: TEXT_PRIMARY,
      font: { size: 12 },
      padding: 16,
    },
  },
};

/** Options for pie/doughnut charts - no white background */
export const pieChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        color: TEXT_PRIMARY,
        font: { size: 12 },
        padding: 16,
        usePointStyle: true,
      },
    },
  },
};

/** Options for line/bar charts - dark grid, light ticks */
export const lineChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      labels: {
        color: TEXT_PRIMARY,
        font: { size: 12 },
        padding: 16,
      },
    },
  },
  scales: {
    x: {
      grid: { color: GRID_COLOR },
      ticks: { color: TEXT_SECONDARY },
    },
    y: {
      grid: { color: GRID_COLOR },
      ticks: { color: TEXT_SECONDARY },
    },
  },
};

/** Options for bar charts */
export const barChartOptions = {
  ...lineChartOptions,
};

/** Options for doughnut charts */
export const doughnutChartOptions = {
  ...pieChartOptions,
};
